// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"3aed6746","224":"03c33800","240":"b70cd1d7","369":"5d1b59fb","568":"7b4b8408","735":"e01de689","784":"43a267bd"}[chunkId] + ".chunk.js";
};